import { createRouter, createWebHashHistory } from "vue-router";
import { Modal } from "ant-design-vue";
import routes, { constantRoutes } from "./routes";
import usePermission from "@/store/modules/permission";
import dayjs from "dayjs";
import useAccount from "@/store/modules/account";
import cache from "@/utils/cache";
import { ACCOUNT, CAS_ACCOUNTS, CAS_TOKEN, TOKEN } from "@/global/constant";
import { useSetAccount } from "@/hooks/account/index";
import { useEmitPageView } from "@/plugins/gtag";
import { useUpdateVersionAndReload } from "@/hooks";

const router = createRouter({
  routes,
  history: createWebHashHistory()
});
const authorized: string[] = constantRoutes.map((item) => item.path);

const pageTime: Record<string, any> = {
  enterPage: "",
  enterTime: "",
  leaveTime: "",
  enterPath: ""
};

router.beforeEach((to) => {
  pageTime.enterPage = to.name;

  // 从飞书跳过来的，携带casToken、用户表和from=cas标识
  if (to.query.from === "cas" && to.path === "/login") {
    const CASToken = to.query.accessToken || "";
    const accounts = to.query.user || "";
    cache.setCache(CAS_TOKEN, CASToken);
    cache.setCache(CAS_ACCOUNTS, accounts);
    router.replace({
      path: "/login",
      query: {}
    });
    return;
  }

  if (authorized.includes(to.path)) {
    return;
  }
  usePermission().initCurrentPageBtns(to.path);
  useUpdateVersionAndReload();

  // 从旧系统跳转过来的，只要携带了token，将用户信息缓存起来
  const account = useAccount();
  if (to.query.token) {
    const token = to.query.token || "";
    account.setToken(token as string);
    cache.setCache(TOKEN, token);
    // token/用户信息可视化不安全 影藏部分信息 保留query
    const params: any = {};
    const secretQuery = ["token"];
    for (const key in to.query) {
      if (!secretQuery.includes(key)) {
        params[key] = to.query[key];
      }
    }
    router.replace({
      path: to.path,
      query: params
    });
  } else {
    const [token] = useSetAccount();
    if (!token) {
      return "/login";
    }
  }
});

router.afterEach((to, from) => {
  if (from.path === pageTime.enterPath) {
    pageTime.leaveTime = dayjs();
    const { enterTime, leaveTime } = pageTime;
    // GA上报数据
    useEmitPageView({
      page_name: from.name as string,
      page_path: from.fullPath,
      enter_time: enterTime,
      leave_time: leaveTime
    });
  }
  pageTime.enterPath = to.path;
  pageTime.enterTime = dayjs();
});

// 错误处理函数，防止每次打包后 客户端路由切换会报错 自动更新代码
router.onError((error, to) => {
  console.log("chunck load error", error);
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    Modal.confirm({
      title: "因版本更新, 页面需要重新载入",
      onOk() {
        window.location.reload();
        router.replace(to.fullPath);
      },
      onCancel() {
        window.location.reload();
        router.replace(to.fullPath);
      }
    });
  }
});

window.onbeforeunload = function () {
  const account = useAccount();
  const { enterPage, enterTime } = pageTime;
  const params = {
    page_name: enterPage,
    user_name: account.userInfo.account || cache.getCache(ACCOUNT)?.account,
    value: dayjs().diff(enterTime, "second")
  };

  // console.log("page view", params);
  window.gtag("event", "page_view", params);
};

export default router;
